var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c("legend", [
        _vm._v(
          "\n    " + _vm._s(_vm._f("pgettext")("Validity", "Contract")) + "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "contract_date",
            label: _vm._f("pgettext")("Contract date", "Contract"),
            labelColsMd: "4",
            contentColsMd: "4",
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormDatetime", {
            attrs: { name: "contract_date" },
            model: {
              value: _vm.contract.contract_date,
              callback: function($$v) {
                _vm.$set(_vm.contract, "contract_date", $$v)
              },
              expression: "contract.contract_date"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "valid_from",
            label: _vm._f("pgettext")("Valid from", "Contract"),
            labelColsMd: "4",
            contentColsMd: "4",
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormDatetime", {
            attrs: { name: "valid_from" },
            model: {
              value: _vm.contract.valid_from,
              callback: function($$v) {
                _vm.$set(_vm.contract, "valid_from", $$v)
              },
              expression: "contract.valid_from"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "valid_to",
            label: _vm._f("pgettext")("Valid to", "Contract"),
            labelColsMd: "4",
            contentColsMd: "4",
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormDatetime", {
            attrs: { name: "valid_to" },
            model: {
              value: _vm.contract.valid_to,
              callback: function($$v) {
                _vm.$set(_vm.contract, "valid_to", $$v)
              },
              expression: "contract.valid_to"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "valid_to",
            label: _vm._f("pgettext")("Auto renewal", "Contract"),
            labelColsMd: "4",
            contentColsMd: "4",
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormCheckbox", {
            attrs: { name: "auto_renewal" },
            model: {
              value: _vm.contract.auto_renewal,
              callback: function($$v) {
                _vm.$set(_vm.contract, "auto_renewal", $$v)
              },
              expression: "contract.auto_renewal"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }